import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {LogoutComponent} from './logout/logout.component';
import {MsalGuard} from '@azure/msal-angular';
import {RevenueComponent} from './revenue/revenue.component';
import {MonitoringComponent} from './monitoring/monitoring.component';
import {AppSettingsComponent} from './app-settings/app-settings.component';
import {ToolsComponent} from './tools/tools.component';
import {LocationComponent} from './location/location.component';
import {ProviderComponent} from './provider/provider.component';
import {JournalEntryComponent} from "./journal-entry/journal-entry.component";


const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: '', component: LoginComponent},
  {path: 'logout', component: LogoutComponent, canActivate: [MsalGuard]},
  {
    path: 'revenue',
    component: RevenueComponent,
    canActivate: [MsalGuard],
    children: [
      {path: '', redirectTo: 'location', pathMatch: 'full'},
      {path: 'monitoring', component: MonitoringComponent},
      {path: 'settings', component: AppSettingsComponent},
      {path: 'tools', component: ToolsComponent},
      {path: 'location', component: LocationComponent},
      {path: 'provider', component: ProviderComponent},
      {path: 'journal-entry', component: JournalEntryComponent},
    ]
  },
  {path: '**', redirectTo: 'revenue'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
